import { AppState } from '../../app-state/app-state';

export const getSchoolActivityById = (id: number) => (state: AppState) => state.schoolActivities.entities[id];

export const getSchoolActivityByInstanceId = (instanceId: number) => (state: AppState) => {
	const instance = state.schoolActivityInstances.entities[instanceId];
	if (!instance) {
		return undefined;
	}
	const activity = state.schoolActivities.entities[instance.activity_id];
	return activity;
};
